ACC.addressDoctorHEDPaypal = {
    _autoload: [
        ['init', document.querySelector('.review-order-page .js-address-doctor')],
    ],

    init() {
        ACC.addressDoctorHED.editedRecommendedAddress = true;
        const { bindPlaceOrderClick, handleAddressDoctorRequest } = ACC.addressDoctorHEDPaypal;

        bindPlaceOrderClick();
        handleAddressDoctorRequest();
    },

    bindPlaceOrderClick() {
        const { placeOrderBtn } = ACC.addressDoctorCheckout;
        const { handleAddressDoctorRequest } = ACC.addressDoctorHEDPaypal;
        const form = $('#billingAddressValidationForm');

        document.querySelector(placeOrderBtn).addEventListener('click', (event) => {
            event.preventDefault();
            if (ACC.addressDoctorHED.editedRecommendedAddress) {
                event.stopImmediatePropagation();
                ACC.buttonhelper.disable(placeOrderBtn);
                handleAddressDoctorRequest();
            } else {
                form.submit();
            }
        });
    },

    handleAddressDoctorRequest() {
        const {
            fetchAddressDoctor,
            bindOriginalAddressTemplateEvents,
            setRecommendedAddresses,
            setOriginalAddresses,
            showAddressDoctorBlock,
            setReenterAddress,
            showReenterAddressDoctorBlock,
        } = ACC.addressDoctorHED;

        const { placeOrderBtn } = ACC.addressDoctorCheckout;

        const {
            bindReenterAddressButton,
            processingOriginalFormForPaypal,
            bindRecommendedTemplateEvents,
        } = ACC.addressDoctorHEDPaypal;

        const userForm = $('#billingAddressValidationForm');

        fetchAddressDoctor(userForm)
            .then((response) => {
                if (response.isValid) {
                    userForm.submit();
                }

                if (!response.suggestedAddresses.length) {
                    setReenterAddress(response.originAddress);
                    bindReenterAddressButton();
                    bindOriginalAddressTemplateEvents(() => processingOriginalFormForPaypal(userForm));
                    showReenterAddressDoctorBlock(true);
                    ACC.buttonhelper.enable(placeOrderBtn);
                    return;
                }
                setRecommendedAddresses(response.suggestedAddresses);
                setOriginalAddresses(response.originAddress);
                showAddressDoctorBlock(true);
                bindRecommendedTemplateEvents({ suggestedAddresses: response.suggestedAddresses, userForm });
                bindOriginalAddressTemplateEvents(() => processingOriginalFormForPaypal(userForm));
                ACC.buttonhelper.enable(placeOrderBtn);
            })
            .catch(() => {
                ACC.buttonhelper.enable(placeOrderBtn);
                ACC.secureacceptance.handlerPlaceOrderBtn();
            });
    },

    bindReenterAddressButton() {
        const { showReenterAddressDoctorBlock, elements: { reenterADBtnClass } } = ACC.addressDoctorHED;
        const reenterAddressBtn = document.querySelector(reenterADBtnClass);
        const form = document.querySelector('#billingAddressValidationForm');

        reenterAddressBtn.addEventListener('click', (e) => {
            e.preventDefault();
            form.scrollIntoView({
                behavior: 'smooth',
            });
            showReenterAddressDoctorBlock(false);
            ACC.addressDoctorHED.editedRecommendedAddress = true;
        });
    },

    bindRecommendedTemplateEvents({ suggestedAddresses, userForm }) {
        const { setDataToUserForm, elements: { recommendedADBtnClass } } = ACC.addressDoctorHED;
        const recommendedAddressBtn = document.querySelectorAll(recommendedADBtnClass);

        recommendedAddressBtn.forEach((item) => item.addEventListener('click', (event) => {
            event.preventDefault();
            ACC.buttonhelper.disable(recommendedAddressBtn);
            const id = event.target.getAttribute('data-id');
            const selectedAddress = suggestedAddresses.find((address, index) => index === Number(id));
            setDataToUserForm(selectedAddress, userForm);
            userForm.find($('#addressValid')).val(true);
            userForm.submit();
        }));
    },

    processingOriginalFormForPaypal(userForm) {
        userForm.find($('#useOriginalAddress')).val(true);
        userForm.submit();
    },
};
